import {useEffect} from 'react'
import {useSnapEngage} from '../../custom-api/hooks/use-snap-engage'
import {useCustomPreferenceWithLocale} from '../../hooks/use-custom-preference'
import {useLocation} from 'react-router-dom'

const SnapEngage = () => {
    const location = useLocation()
    const snapEngageConfig = useCustomPreferenceWithLocale('snapEngageConfiguration')
    const snapEngageWidgetID = snapEngageConfig?.snapEngageWidgetID || ''
    const proactiveChat =
        snapEngageConfig?.proactiveChat === 'true' || snapEngageConfig?.proactiveChat === true

    const snapEnageURLExclusion = snapEngageConfig?.snapEnageURLExclusion || []

    useSnapEngage({snapEngageWidgetID, proactiveChat})

    useEffect(() => {
        let shouldDisableChat = false

        for (let exclusion of snapEnageURLExclusion) {
            try {
                const regex = new RegExp(exclusion)
                if (regex.test(location.pathname)) {
                    shouldDisableChat = true
                    break
                }
            } catch (e) {
                if (location.pathname === exclusion) {
                    shouldDisableChat = true
                    break
                }
            }
        }

        if (window.SnapEngage) {
            window.SnapEngage.allowProactiveChat(!shouldDisableChat)
            shouldDisableChat ? window.SnapEngage.hideButton() : window.SnapEngage.showButton()
        }
    }, [location.pathname, snapEnageURLExclusion])

    return null
}

export default SnapEngage
